module.exports = __webpack_public_path__ + "img/logo-wel-barcode.7ef2e09d.png";